<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';

export default {
  name: 'detail_table',
  extends: TablePage,
  data() {
    return {
      isCalculateHeight: false,
    };
  },
  props: {
    mainId: String,
    taskName: String,
  },
  watch: {
    taskName: {
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.params = { mainId: this.mainId };
    this.getConfigList('detail_list_table_process', null, null, 'CRM20260309000000002');
  },
  methods: {
    // // 按钮状态显隐
    clickVisible({ val, row }) {
      if (val.code === 'reject_nosend') {
        const isShow = row.payoutStatus === 'not' && this.taskName === '市场督察(不可修改)';
        return isShow;
      }
      return true;
    },
    modalClick({ val, row }) {
      if (val.code === 'reject_nosend') {
        this.$confirm('您确定要驳回并不发放吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          request
            .post('/cps/cpsagreerewardprocess/updatePayoutStatus', [
              {
                id: row.id,
                mainId: this.mainId,
              },
            ])
            .then((res) => {
              if (res.success) {
                this.$message.success('操作成功');
                this.getList();
              }
            });
        });
      }
    },
  },
};
</script>
